/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type TriggerAnalysisRequestBody = {
  /**
   * Organization whose projects to signal.
   */
  organizationId: string;
};

/** @internal */
export type TriggerAnalysisRequestBody$Outbound = {
  organization_id: string;
};

/** @internal */
export const TriggerAnalysisRequestBody$outboundSchema: z.ZodMiniType<
  TriggerAnalysisRequestBody$Outbound,
  TriggerAnalysisRequestBody
> = z.pipe(
  z.object({
    organizationId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      organizationId: "organization_id",
    });
  }),
);

export function triggerAnalysisRequestBodyToJSON(
  triggerAnalysisRequestBody: TriggerAnalysisRequestBody,
): string {
  return JSON.stringify(
    TriggerAnalysisRequestBody$outboundSchema.parse(triggerAnalysisRequestBody),
  );
}
